/**
 * Handles scroll animations for sections
 */

// Function to check if an element is in viewport
const isElementInViewport = (el, offset = 100) => {
  const rect = el.getBoundingClientRect();
  return (
    rect.top <= (window.innerHeight || document.documentElement.clientHeight) - offset &&
    rect.bottom >= 0
  );
};

/**
 * Initialize scroll animations
 * Shows elements with 'section' class as they come into view
 */
export function initScrollAnimations() {
    const sections = document.querySelectorAll('.section');
    const header = document.querySelector('.header');

    // Initial check for sections in viewport
    checkSections(sections);

    // Throttle scroll/resize with requestAnimationFrame
    let scrollPending = false;
    window.addEventListener('scroll', () => {
        if (!scrollPending) {
            scrollPending = true;
            requestAnimationFrame(() => {
                checkSections(sections);
                handleHeaderScroll(header);
                scrollPending = false;
            });
        }
    });

    let resizePending = false;
    window.addEventListener('resize', () => {
        if (!resizePending) {
            resizePending = true;
            requestAnimationFrame(() => {
                checkSections(sections);
                resizePending = false;
            });
        }
    });
    
    // Initial header state check
    handleHeaderScroll(header);
    
    // Add parallax effect to sections
    initParallaxEffects();

    // Set staggered transition delays (must run after publications are rendered)
    document.querySelectorAll('.timeline-item').forEach((item, index) => {
        item.style.transitionDelay = `${index * 0.05}s`;
    });
    document.querySelectorAll('.publication-item').forEach((item, index) => {
        item.style.transitionDelay = `${index * 0.05}s`;
    });
    document.querySelectorAll('.course').forEach((item, index) => {
        item.style.transitionDelay = `${index * 0.05}s`;
    });
}

/**
 * Check if sections are in viewport and add 'visible' class
 * @param {NodeList} sections - The sections to check
 */
function checkSections(sections) {
    sections.forEach(section => {
        const sectionTop = section.getBoundingClientRect().top;
        const windowHeight = window.innerHeight;
        
        // If section is in viewport (with offset)
        if (sectionTop < windowHeight * 0.85) {
            section.classList.add('visible');
            
            // Animate children with staggered delay (skip already-animated)
            const animatableElements = section.querySelectorAll('.timeline-item, .course, .publication-item');
            animatableElements.forEach((el, index) => {
                if (el.classList.contains('animate')) return;
                setTimeout(() => {
                    el.classList.add('animate');
                    el.style.opacity = '1';
                    el.style.transform = 'translateY(0)';
                }, 100 * index);
            });
        }
    });
}

/**
 * Handle header scroll effects
 * @param {HTMLElement} header - The header element
 */
function handleHeaderScroll(header) {
    if (!header) return;
    
    if (window.scrollY > 100) {
        header.classList.add('scrolled');
    } else {
        header.classList.remove('scrolled');
    }
}

/**
 * Initialize parallax effects on supported elements
 */
function initParallaxEffects() {
    // Add a subtle parallax effect to hero image
    const heroImage = document.querySelector('.hero-image');
    const hero = document.querySelector('.hero');
    if (heroImage) {
        let mousePending = false;
        window.addEventListener('mousemove', (e) => {
            if (mousePending) return;
            if (hero && !isElementInViewport(hero, 0)) return;
            mousePending = true;
            requestAnimationFrame(() => {
                const x = e.clientX / window.innerWidth;
                const y = e.clientY / window.innerHeight;
                heroImage.style.transform = `translate(${x * 10 - 5}px, ${y * 10 - 5}px)`;
                mousePending = false;
            });
        });
    }
    
    // Add tilt effect to specialty tags
    const specialtyTags = document.querySelectorAll('.specialty-tag');
    specialtyTags.forEach(tag => {
        tag.addEventListener('mousemove', (e) => {
            const rect = tag.getBoundingClientRect();
            const x = (e.clientX - rect.left) / rect.width - 0.5;
            const y = (e.clientY - rect.top) / rect.height - 0.5;
            
            tag.style.transform = `perspective(300px) rotateX(${y * -5}deg) rotateY(${x * 5}deg) translateY(-3px)`;
        });
        
        tag.addEventListener('mouseleave', () => {
            tag.style.transform = '';
        });
    });
    
    // Add hover effect to section titles
    const sectionTitles = document.querySelectorAll('.section-title');
    sectionTitles.forEach(title => {
        title.addEventListener('mouseenter', () => {
            title.style.backgroundSize = '100% 100%';
        });
        
        title.addEventListener('mouseleave', () => {
            title.style.backgroundSize = '0% 100%';
        });
    });
}

